import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-hero-container',
  templateUrl: './hero-container.component.html',
  styleUrls: ['./hero-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HeroContainerComponent {
  @Input()
  imgSrc: string;

  @Input()
  imgCenter = 'center'; // ex "bottom left", "10% 50%"

  @Input()
  imgDesktopSrc: string;

  @Input()
  imgDesktopCenter: string;

  @Input()
  variant: 'keepContentSize' | 'keepImageSize' = 'keepContentSize';
}
